import { buildModelManager } from "../builder.js";
const DefaultSubscriptionPlanSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customPlan: true,
  interval: true,
  name: true,
  orders: true,
  price: true,
  type: true,
  updatedAt: true
};
const modelApiIdentifier = "subscriptionPlan";
const pluralModelApiIdentifier = "subscriptionPlans";
;
;
;
;
;
;
;
;
;
const SubscriptionPlanManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSubscriptionPlanSelection,
  [
    {
      type: "findOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "findMany",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "findFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "maybeFindFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultSubscriptionPlanSelection,
      namespace: null
    },
    {
      type: "action",
      operationName: "createSubscriptionPlan",
      operationReturnType: "CreateSubscriptionPlan",
      functionName: "create",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        subscriptionPlan: { required: false, type: "CreateSubscriptionPlanInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultSubscriptionPlanSelection
    },
    {
      type: "action",
      operationName: "bulkCreateSubscriptionPlans",
      functionName: "bulkCreate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "create",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkCreateSubscriptionPlansInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultSubscriptionPlanSelection
    },
    {
      type: "action",
      operationName: "updateSubscriptionPlan",
      operationReturnType: "UpdateSubscriptionPlan",
      functionName: "update",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        subscriptionPlan: { required: false, type: "UpdateSubscriptionPlanInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultSubscriptionPlanSelection
    },
    {
      type: "action",
      operationName: "bulkUpdateSubscriptionPlans",
      functionName: "bulkUpdate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "update",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpdateSubscriptionPlansInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultSubscriptionPlanSelection
    },
    {
      type: "action",
      operationName: "deleteSubscriptionPlan",
      operationReturnType: "DeleteSubscriptionPlan",
      functionName: "delete",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: true,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "bulkDeleteSubscriptionPlans",
      functionName: "bulkDelete",
      isBulk: true,
      isDeleter: true,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "delete",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: null
    },
    {
      type: "action",
      operationName: "upsertSubscriptionPlan",
      operationReturnType: "UpsertSubscriptionPlan",
      functionName: "upsert",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        on: { required: false, type: "[String!]" },
        subscriptionPlan: { required: false, type: "UpsertSubscriptionPlanInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["on"],
      hasReturnType: {
        "... on CreateSubscriptionPlanResult": { hasReturnType: false },
        "... on UpdateSubscriptionPlanResult": { hasReturnType: false }
      },
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultSubscriptionPlanSelection
    },
    {
      type: "action",
      operationName: "bulkUpsertSubscriptionPlans",
      functionName: "bulkUpsert",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "upsert",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpsertSubscriptionPlansInput!]" }
      },
      paramOnlyVariables: ["on"],
      defaultSelection: DefaultSubscriptionPlanSelection
    }
  ]
);
export {
  DefaultSubscriptionPlanSelection,
  SubscriptionPlanManager
};
//# sourceMappingURL=SubscriptionPlan.js.map
